import {
  getCountDistribution,
  getCountDistributionNumeric,
  getDistributionAgainstTarget,
  getDistributionAgainstTargetNumeric,
} from "./distribution";

const getCountDistributionPlots = (plots, driverVariables, node) => {
  const plotItem = plots.find(item => item.column_id === node.data.label);
  if (plotItem?.["@type"] === "numeric") {
    return getCountDistributionNumeric(plotItem);
  } else if (plotItem?.["@type"] in ["categorical", "ordinal"]) {
    return getCountDistribution(plotItem, node, driverVariables);
  }

  return undefined;
};

const getDistributionAgainstTargetPlots = (
  plots,
  node,
  driverVariables,
  type
) => {
  if (type === "numeric") {
    const plotItem = plots.find(
      item => item.numeric_column_id === node.data.label
    );
    return getDistributionAgainstTargetNumeric(plotItem);
  } else if (type === "categorical" || type === "ordinal") {
    const plotItem = plots.find(
      item => item.second_column_id === node.data.label
    );
    return getDistributionAgainstTarget(plotItem, node, driverVariables);
  }

  return undefined;
};

const getPlots = (plotsList, driverVariables, node) => {
  const countDistribution = getCountDistributionPlots(
    plotsList,
    driverVariables,
    node
  );
  const distributionAgainstTarget = getDistributionAgainstTargetPlots(
    plotsList,
    node,
    driverVariables,
    plotsList.find(item => item.column_id === node.data.label)?.["@type"]
  );
  return { countDistribution, distributionAgainstTarget };
};

export { getPlots };
